<template>
  <div class="relative h-full w-full overflow-y-auto pr-1">
    <div class="flex flex-col overflow-hidden">
      <TransitionGroup name="flash">
        <div
          v-for="importSource in importSources"
          :key="importSource?.id"
          class="break-inside-avoid rounded-md"
        >
          <ImportSourceCard
            v-if="
              importSource?.id &&
              (isBuiltInImportSource(importSource.id) ||
                importSource.type === ImportSourceType.FIELD_SAFETY_NOTICES) &&
              ![
                BuiltInImportSourceId.HAND_SEARCH as string,
                BuiltInImportSourceId.CITATION_SEARCH as string,
              ].includes(importSource.id)
            "
            :import-source="importSource"
            :icon-url="importSource.iconUrl"
            :query="generateSearchQuery(importSource.id, review.entity.value)"
          />

          <ImportFromCustomSource
            v-else-if="
              ![
                BuiltInImportSourceId.HAND_SEARCH,
                BuiltInImportSourceId.CITATION_SEARCH,
              ].includes(importSource.id as BuiltInImportSourceId)
            "
            :import-source="importSource"
          />
        </div>

        <HandSearch
          v-if="
            review.entity.value.plan?.importPlan.importSources?.some(
              (i) => i.id === BuiltInImportSourceId.HAND_SEARCH,
            )
          "
          key="hand-search"
        />
      </TransitionGroup>
    </div>
  </div>
</template>
<script setup lang="ts">
import { injectStrict } from '@app/utils/injectStrict'
import { generateSearchQuery } from '@app/utils/generateSearchQuery/generateSearchQuery'
import { ReviewKey } from '../../../use-review'
import { computed } from 'vue'
import { BuiltInImportSourceId } from '@core/domain/types/builtInImportSourceId'
import ImportFromCustomSource from './CustomImportSource/ImportFromCustomSource.vue'
import HandSearch from './HandSearch/HandSearch.vue'
import useBuiltInImportSources from '@app/composables/use-built-in-import-sources'
import ImportSourceCard from '../Components/ImportSourceCard.vue'
import { SafetyInformationSourcesKey } from '@app/injectionKeys'
import { ImportSourceType } from '@core/domain/types/import-source-type.type'

const review = injectStrict(ReviewKey)
const builtInImportSources = useBuiltInImportSources()
const safetyInformationSources = injectStrict(SafetyInformationSourcesKey)

const importSources = computed(() => {
  return review.entity.value.plan?.importPlan.importSources
    ?.map((s) => {
      const source = { ...s }
      const builtInSource = builtInImportSources.findById(source.id)
      if (builtInSource) {
        source.iconUrl = builtInSource.iconUrl
      } else {
        const safetyInformationSource = safetyInformationSources.find(
          (s) => s.id === source.id,
        )

        if (safetyInformationSource) {
          source.iconUrl = safetyInformationSource.country.flagUrl
        }
      }
      return source
    })
    .sort((a, b) => a.order - b.order)
    .sort((a, b) => {
      const aLength = review.searchesBySource.value?.[a.id]?.length || 0
      const bLength = review.searchesBySource.value?.[b.id]?.length || 0

      if (aLength > 0 && bLength === 0) {
        return -1
      } else if (aLength === 0 && bLength > 0) {
        return 1
      } else {
        return 0
      }
    })
})

const isBuiltInImportSource = (
  importSourceId: string,
): importSourceId is BuiltInImportSourceId => {
  return Object.values(BuiltInImportSourceId).includes(
    importSourceId as BuiltInImportSourceId,
  )
}
</script>
